import { Breakpoints, ContainerPadding } from '@volkswagen-onehub/components-core';
import React from 'react';
import { LayoutExtended } from './core/layout-extended';
import { Group } from './group';

interface Props {
	children: React.ReactNode;
	paddingTop?: ContainerPadding;
	paddingBottom?: ContainerPadding;
}

export function InputsGroup(props: Props) {
	const { children } = props;

	// No usamos la propiedad rowGap en Layout pq los margenes verticales los gestina el propio Input

	const childrenArray = React.Children.toArray(children);
	const isOdd = childrenArray.length % 2 !== 0;

	return (
		<Group {...props}>
			<LayoutExtended
				allowOverflowingContent
				appearance={{
					[Breakpoints.default]: [{ name: 'a', columns: 24 }],
					[Breakpoints.b560]: [{ name: 'a', columns: 12 }],
				}}
			>
				{children}
				{isOdd && <div />}
			</LayoutExtended>
		</Group>
	);
}
